import React from "react";
import { columnLeft, columnsWidth, PlanGrid } from "modules/spending/workload-plan/models/plan-scale";
import styles from "./PlanTrack.module.scss";

/** Классы полос — общие для строки участника и для свёрнутой строки проекта */
export const trackStyles = styles;

interface PlanTrackProps {
    grid: PlanGrid;
    /** Левые края разделителей месяцев, px */
    monthBreaks: number[];
    /** Слот, выделенный кликом по шапке */
    selectedSlot: { start: number; length: number } | null;
    /** Дополнительный класс: разделитель у строки участника и у строки проекта разный */
    className?: string;
    children?: React.ReactNode;
}

/**
 * Дорожка сетки: ячейки, прошлое, текущий день, пустые недели и границы месяцев.
 * Одна на все строки страницы — иначе шапка, строки проектов и строки участников
 * разъезжаются между собой при первой же правке фона.
 */
export const PlanTrack: React.FC<PlanTrackProps> = React.memo((props) => {
    const { grid, monthBreaks, selectedSlot, className, children } = props;

    // прошлое приглушается до начала текущего слота — неделя целиком не «прошлая»
    const firstFuture = grid.slots.find((slot) => !slot.isPast);
    const pastWidth = firstFuture ? firstFuture.left : grid.totalWidth;
    const today = grid.slots.find((slot) => slot.isToday) || null;

    return (
        <div
            className={className ? `${styles.track} ${className}` : styles.track}
            style={
                {
                    width: grid.totalWidth,
                    // полоски фона идут по границам слотов — как колонки в шапке
                    "--wp-grid-step": `${grid.slotWidth}px`,
                } as React.CSSProperties
            }
        >
            {pastWidth > 0 && <div className={styles.past} style={{ width: pastWidth }} />}

            {today && <div className={styles.today} style={{ left: today.left, width: today.width }} />}

            {selectedSlot && (
                <div
                    className={styles.columnMark}
                    style={{
                        left: columnLeft(grid, selectedSlot.start),
                        width: columnsWidth(grid, selectedSlot.start, selectedSlot.length),
                    }}
                />
            )}

            {grid.slots.map((slot) =>
                slot.isEmpty ? (
                    <div
                        key={`empty_${slot.left}`}
                        className={styles.emptyWeek}
                        style={{ left: slot.left, width: slot.width }}
                        data-tip="Рабочих дней на этой неделе нет"
                    />
                ) : null
            )}

            {monthBreaks.map((left) => (
                <div key={left} className={styles.monthBreak} style={{ left }} />
            ))}

            {children}
        </div>
    );
});

PlanTrack.displayName = "PlanTrack";
